import { Component, Input, OnInit, OnDestroy, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { AuthenticationService } from '../../../services/auth/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { MixpanelService } from 'src/app/mixpanel.service';
// declare var myExternalJs: any;
import { SharedService } from 'src/app/services/api/message.service';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { Subscription } from 'rxjs';
import { DirectivesModule } from 'src/app/directives.module';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from 'src/app/services/api/consumer/dashboard.service';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { an } from '@fullcalendar/core/internal-common';
import { CompleteProfileChartComponent } from '../complete-profile-chart/complete-profile-chart.component';
import { AvailabilityChartComponent } from '../availability-chart/availability-chart.component';
import { ArticleComponent } from '../../producer/article/article.component';
import { SchoolData } from 'src/app/models/schoolUser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: true,
  imports: [
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    CommonAnnouncementComponent,
    CommonModule,
    CarouselModule,
    CompleteProfileChartComponent,
    AvailabilityChartComponent,
    ArticleComponent
  ],
})
export class DashboardComponent implements OnInit, OnDestroy {
  school_count: any;
  email_job_alert_near: any;
  goToProfile() {
    this.router.navigate(['teacher/profile']);
  }
  findNewSchools() {
    this.router.navigate(['teacher/find-new-schools']);
  }
  goTojobs() {
    window.open(`https://jobs-test.classcover.com.au/teacher/jobs`, '_blank');
  }
  goToCalendar() {
    this.router.navigate(['teacher/calendar']);
  }
  date_month: any;
  ngOnDestroy(): void {
    window.removeEventListener('resize', this.updateItemsPerSlide);
  }
  dashboardData: any;
  nonPromotedJobs: any;
  promotedJobs: any;
  paidCourses: any;
  promotion_course: any;
  teacher_fortnight: any;
  upcomingBookings: any;
  availability_health: any;
  teacherProfile: any;
  schoolProps!: SchoolData;
  itemsPerSlide = 3; // Default value

  constructor(
    private router: Router,
    private loginFormFB: FormBuilder,
    private authService: AuthenticationService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private mixpanelService: MixpanelService,
    private sharedService: SharedService,
    private toastr: ToastrService,
    private DashboardService: DashboardService,
    private zone: NgZone
  ) { }

  updateItemsPerSlide = () => {
    const width = window.innerWidth;
    this.zone.run(() => {
      if (width < 576) {
        this.itemsPerSlide = 1;
      } else if (width < 992) {
        this.itemsPerSlide = 2;
      } else {
        this.itemsPerSlide = 3;
      }
    });
  };

  // SVG arc path for progress ring
  getProfileProgressArc(percent?: number): string {
    const r = 47;
    const cx = 60;
    const cy = 60;
    // Use argument if provided, else fallback to this.profileCompletion
    const pct =
      percent !== undefined
        ? Math.max(0, Math.min(100, percent))
        : Math.max(0, Math.min(100, this.profileCompletion));
    if (pct === 100) {
      // Full circle: draw two arcs to ensure visibility
      const start = this.polarToCartesian(cx, cy, r, 90);
      const mid = this.polarToCartesian(cx, cy, r, 270);
      return [
        'M',
        start.x,
        start.y,
        'A',
        r,
        r,
        0,
        1,
        1,
        mid.x,
        mid.y,
        'A',
        r,
        r,
        0,
        1,
        1,
        start.x,
        start.y,
      ].join(' ');
    }
    const angle = (pct / 100) * 360;
    // Start at top (12 o'clock)
    const startAngle = 90; // 0 degrees is at 3 o'clock, so -90 starts at 12 o'clock
    const endAngle = startAngle + angle;

    // Convert angles to radians
    const start = this.polarToCartesian(cx, cy, r, startAngle);
    const end = this.polarToCartesian(cx, cy, r, endAngle);

    const largeArcFlag = pct > 50 ? 1 : 0;

    return [
      'M',
      start.x,
      start.y,
      'A',
      r,
      r,
      0,
      largeArcFlag,
      1,
      end.x,
      end.y,
    ].join(' ');
  }

  polarToCartesian(cx: number, cy: number, r: number, angle: number) {
    const rad = ((angle - 90) * Math.PI) / 180.0;
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  }
  profileCompletion = 15; // percent, set to 15 for your example

  getSmallProfileDashOffset(availability_health: number): string {
    const r = 35;
    const circumference = 2 * Math.PI * r;
    var adjustedHealth = 100 - availability_health; // Adjusted to subtract 100
    const percent = Math.max(0, Math.min(100, adjustedHealth));
    const offset = circumference - (circumference * percent) / 100;
    return offset.toFixed(3);
  }

  getSmallProfileDashArray(_availability_health?: number): string {
    const r = 35;
    return (2 * Math.PI * r).toFixed(3);
  }

  getProfileProgressDashOffset(): string {
    // Calculate offset based on profileCompletion, always >= 0
    const percent = Math.max(0, Math.min(100, this.profileCompletion));
    const circumference = parseFloat(
      DashboardComponent.PROFILE_RING_CIRCUMFERENCE
    );
    const offset = circumference - (circumference * percent) / 100 - 100;
    return offset.toFixed(3);
  }
  getProfileProgressDashArray(): string {
    // Return the circumference for the SVG ring
    return DashboardComponent.PROFILE_RING_CIRCUMFERENCE;
  }
  static PROFILE_RING_CIRCUMFERENCE = (2 * Math.PI * 35).toFixed(3); // r=35

  ngOnInit(): void {
    this.updateItemsPerSlide();
    window.addEventListener('resize', this.updateItemsPerSlide);
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');

    this.ngxService.start();
    this.DashboardService.teachersDashboardAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.dashboardData = res.data;
          this.nonPromotedJobs = res.data.job_list.non_promoted_job;
          this.promotedJobs = res.data.job_list.promoted_job;
          this.paidCourses = res.data.courses.paid_course;
          this.promotion_course = res.data.courses.promotion_course;
          this.teacherProfile = res.data.teacher_profile;
          this.email_job_alert_near = res?.data?.email_job_alert_near;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
    this.DashboardService.teachersDashboardBookingsAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.availability_health = res.data.availability_health;
          this.upcomingBookings = res.data.upcoming_bookings;
          this.teacher_fortnight = res.data.teacher_fortnight;
          this.date_month = res.data.date_month;
          this.school_count = res.data.school_count;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  getLoadDataOnSave() {
    this.ngxService.start();
    this.DashboardService.teachersDashboardAPI().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.nonPromotedJobs = res.data.job_list.non_promoted_job;
          this.promotedJobs = res.data.job_list.promoted_job;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  nextClick() {
    const resultDate = this.getShiftedAvailabilityDate(7);
    if (!resultDate) {
      this.toastr.error('Unable to determine next date. Please refresh and try again.');
      return;
    }
    this.nextPrev(resultDate);
  }
  prevClick() {
    const resultDate = this.getShiftedAvailabilityDate(-7);
    if (!resultDate) {
      this.toastr.error('Unable to determine previous date. Please refresh and try again.');
      return;
    }
    this.nextPrev(resultDate);
  }

  private getShiftedAvailabilityDate(days: number): string | null {
    const parsedDate = this.getAvailabilityAnchorDate();
    if (!parsedDate) {
      return null;
    }

    parsedDate.setDate(parsedDate.getDate() + days);
    return this.formatDateForApi(parsedDate);
  }

  private getAvailabilityAnchorDate(): Date | null {
    const firstAvailability = this.teacher_fortnight?.availability?.[0];
    if (!firstAvailability) {
      return null;
    }

    const directDateCandidates = [
      firstAvailability?.intervals?.[0]?.date,
      firstAvailability?.date_format,
      firstAvailability?.date_full,
    ];

    for (const candidate of directDateCandidates) {
      if (typeof candidate === 'string' && candidate.trim()) {
        const parsed = this.parseAvailabilityDate(candidate);
        if (parsed) {
          return parsed;
        }
      }
    }

    const day = Number(firstAvailability?.date);
    const monthIndex = this.getMonthIndex(firstAvailability?.month);
    const fallbackMonthIndex = this.getMonthIndex(this.date_month);
    const year = this.getYearFromDateMonth() ?? new Date().getFullYear();
    const chosenMonthIndex = monthIndex ?? fallbackMonthIndex;

    if (!isNaN(day) && chosenMonthIndex !== null) {
      const constructedDate = new Date(year, chosenMonthIndex, day);
      if (
        constructedDate.getFullYear() === year &&
        constructedDate.getMonth() === chosenMonthIndex &&
        constructedDate.getDate() === day
      ) {
        return constructedDate;
      }
    }

    return null;
  }

  private parseAvailabilityDate(input: string): Date | null {
    const value = input.trim();

    // Guard against day-only values like "25" that JS Date() can coerce unexpectedly.
    if (/^\d{1,2}$/.test(value)) {
      return null;
    }

    const dayFirstMatch = value.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
    if (dayFirstMatch) {
      const day = Number(dayFirstMatch[1]);
      const month = Number(dayFirstMatch[2]);
      const year = Number(dayFirstMatch[3]);
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      ) {
        return date;
      }
      return null;
    }

    const yearFirstMatch = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (yearFirstMatch) {
      const year = Number(yearFirstMatch[1]);
      const month = Number(yearFirstMatch[2]);
      const day = Number(yearFirstMatch[3]);
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      ) {
        return date;
      }
      return null;
    }

    const fallbackDate = new Date(value);
    return isNaN(fallbackDate.getTime()) ? null : fallbackDate;
  }

  private formatDateForApi(date: Date): string {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  private getMonthIndex(value: unknown): number | null {
    if (typeof value !== 'string' || !value.trim()) {
      return null;
    }

    const monthMap: { [key: string]: number } = {
      jan: 0,
      january: 0,
      feb: 1,
      february: 1,
      mar: 2,
      march: 2,
      apr: 3,
      april: 3,
      may: 4,
      jun: 5,
      june: 5,
      jul: 6,
      july: 6,
      aug: 7,
      august: 7,
      sep: 8,
      sept: 8,
      september: 8,
      oct: 9,
      october: 9,
      nov: 10,
      november: 10,
      dec: 11,
      december: 11,
    };

    const tokens = value.toLowerCase().match(/[a-z]+/g);
    if (!tokens || tokens.length === 0) {
      return null;
    }

    for (const token of tokens) {
      if (token in monthMap) {
        return monthMap[token];
      }
    }

    return null;
  }

  private getYearFromDateMonth(): number | null {
    if (typeof this.date_month !== 'string') {
      return null;
    }

    const match = this.date_month.match(/\b(\d{4})\b/);
    return match ? Number(match[1]) : null;
  }

  getIntervalLabel(status: string): string {
    const statusLabelMap: { [key: string]: string } = {
      available: 'A',
      haventindicated: 'HI',
      booked: 'B',
      booked_externally: 'BE',
      unavailable: 'UA',
    };

    return statusLabelMap[status] ?? 'HI';
  }

  getIntervalClass(status: string): string {
    const knownStatuses = [
      'available',
      'haventindicated',
      'booked',
      'booked_externally',
      'unavailable',
    ];

    return knownStatuses.includes(status) ? status : 'haventindicated';
  }

  nextPrev(date: string | null) {
    this.ngxService.start();
    this.DashboardService.nextPrevAPI(date).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.teacher_fortnight = res.data;
          this.date_month = res.date_month;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }

  jobSaveUnsaveAPI(jobId: any, action: string): void {
    this.ngxService.start();
    this.DashboardService.jobSaveUnsaveAPI(jobId, action).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.getLoadDataOnSave();
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  getJobAlert(event: any): void {
    // Determine checked state and action
    const checked = (event.target as HTMLInputElement)?.checked;
    const value = checked ? 1 : 0;
    const action = 'job_dashboard';
    // this.ngxService.start();
    this.DashboardService.getJobAlertAPI(value, action).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.status) {
          this.toastr.success(res.message);
          // this.router.navigate([this.router.url]);
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }

  viewDetails(slidelink: any) {
    window.open(slidelink, '_blank');
  }
  handlePageData(data: any) {
    // Store the page data for later use, e.g. pagination or display
    this.pageData = data;
    // Optionally, update the UI or trigger other logic if needed
    // Example: this.obsArray.next(data.consumer_list || []);
  }
  pageData: any;

  openClassCover() {
    this.ngxService.start();
    this.commonService.learnworldLogin().subscribe({
      next: (res: any) => {
        // console.log(res);
        if (res.status) {
          window.open(res.response.url, '_self');
        } else {
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      }
    });
  }
  openPromotionLink(link: string) {
    window.open(link, '_blank', 'noopener,noreferrer');
  }
}
